module.exports = __webpack_public_path__ + "img/img3_10.913be3d2.jpeg";